import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import '../../assets/scss/custom/components/_progress-bar.scss';

const ProgressBar = ({
  progress = 0,
  message = '',
  isVisible = false,
  variant = 'default',
  size = 'md',
  showPercentage = true,
  autoHide = true,
  className = '',
  onComplete,
  ...props
}) => {
  const [isComplete, setIsComplete] = useState(false);
  const [shouldHide, setShouldHide] = useState(false);

   useEffect(() => {
    if (progress >= 100 && !isComplete) {
      setIsComplete(true);
      onComplete?.();
    
      if (autoHide) {
        setTimeout(() => {
          setShouldHide(true);
        }, 2000);
      }
    } else if (progress < 100) {
      setIsComplete(false);
      setShouldHide(false);
    }
  }, [progress, isComplete, autoHide, onComplete]);

  if (!isVisible || shouldHide) {
    return null;
  }

  const getStateClass = () => {
    if (isComplete) return 'complete';
    if (progress > 0) return 'loading';
    return '';
  };

  return (
    <div
      className={`progress-bar-container ${getStateClass()} ${className}`}
      role="progressbar"
      aria-valuenow={progress}
      aria-valuemin="0"
      aria-valuemax="100"
      aria-label={message || `Progresso: ${progress}%`}
      {...props}
    >
      <h5 className="progress-title">Exportando...</h5>
      
      <div className="progress-bar-wrapper">
        <div className="progress-bar">
          <div
            className="progress-fill"
            style={{ width: `${Math.min(progress, 100)}%` }}
          >
            {showPercentage && progress > 0 && (
              <span className="progress-percentage">
                {Math.round(progress)}%
              </span>
            )}
          </div>
        </div>
        
        {message && (
          <div className="progress-message">
            {message}
          </div>
        )}
      </div>
    </div>
  );
};

ProgressBar.propTypes = {
  progress: PropTypes.number,
  message: PropTypes.string,
  isVisible: PropTypes.bool,
  variant: PropTypes.oneOf(['default', 'success', 'warning', 'danger', 'info']),
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
  showPercentage: PropTypes.bool,
  autoHide: PropTypes.bool,
  className: PropTypes.string,
  onComplete: PropTypes.func,
};

export default ProgressBar;
